import { nameOf } from "../../../../utils/functions/ReflectionUtil";
import { ColumnField } from "../../../components/GenericTable/SubComponents/Column";
import { Role } from "../../../../core/models/entities/Role";
import { Design } from "../../../../core/models/entities/Design";
import { useProfileContext } from "../../../../contexts/ProfileContext";

export function designColumnsConfig(showVendorColumn: boolean = false) {
  const { role } = useProfileContext();

  // Vendor column (only for Admin role)
  const vendorColumn = {
    value: "vendor",
    canSortBy: true,
    displayValue: "Vendor",
    weight: 1,
  } as ColumnField;

  const baseColumns = [
    {
      value: nameOf<Design>((x) => x.displayImage),
      canSortBy: false,
      displayValue: "Image",
      weight: 1,
    },
    {
      value: "product.mul",
      canSortBy: true,
      displayValue: "MUL",
      weight: 1.3,
    },
    {
      value: nameOf<Design>((x) => x.title),
      canSortBy: true,
      displayValue: "Title",
      weight: 0,
    },
  ];

  // Customer column
  const customerColumn = {
    value: nameOf<Design>((x) => x.customer),
    canSortBy: true,
    displayValue: "Customer",
    weight: 1.65,
  } as ColumnField;

  const remainingColumns = [
    {
      value: nameOf<Design>((x) => x.createdAtUtc),
      canSortBy: true,
      displayValue: "Creation Date",
      weight: 1.2,
    },
    {
      value: nameOf<Design>((x) => x.status),
      canSortBy: true,
      displayValue: "Status",
      weight: role === Role.EndUser ? 2 : 1.5,
    },
    {
      value: "action",
      canSortBy: false,
      displayValue: "Action",
      weight: 1.5,
    },
  ];

  const columns: ColumnField[] = [...baseColumns];

  // Add vendor column before customer column if requested (for Admin role)
  if (showVendorColumn) {
    columns.push(vendorColumn);
  }

  // Always add customer column
  columns.push(customerColumn);

  columns.push(...remainingColumns);

  return columns;
}
